import { MenuItem } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Tooltip from "@mui/material/Tooltip";
import { useContext, useRef, useState } from "react";
import { InfoCircle } from "react-bootstrap-icons";
import "../../../../Tooltip/styles/tooltip.css";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider";
import { FormContext } from "../context/FormProvider.jsx";
import * as Messages from "../messages/messages.js";
import "../styles/form-container.css";
import "./styles/new-select.css";

const NewSelect = ({
  idProp,
  label,
  val,
  state,
  setState,
  req,
  debouncedSave,
  setIsLoading,
  type,
  disabledInput,
  invalidData,
}) => {
  const textRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { requestStatus, handleInputDisable } = useContext(FormContext);
  const { userId } = useContext(DashboardContext);

  const [states, setStates] = useState({
    Alabama: "AL",
    Alaska: "AK",
    Arizona: "AZ",
    Arkansas: "AR",
    California: "CA",
    Colorado: "CO",
    Connecticut: "CT",
    Delaware: "DE",
    Florida: "FL",
    Georgia: "GA",
    Hawaii: "HI",
    Idaho: "ID",
    Illinois: "IL",
    Indiana: "IN",
    Iowa: "IA",
    Kansas: "KS",
    Kentucky: "KY",
    Louisiana: "LA",
    Maine: "ME",
    Maryland: "MD",
    Massachusetts: "MA",
    Michigan: "MI",
    Minnesota: "MN",
    Mississippi: "MS",
    Missouri: "MO",
    Montana: "MT",
    Nebraska: "NE",
    Nevada: "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    Ohio: "OH",
    Oklahoma: "OK",
    Oregon: "OR",
    Pennsylvania: "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    Tennessee: "TN",
    Texas: "TX",
    Utah: "UT",
    Vermont: "VT",
    Virginia: "VA",
    Washington: "WA",
    "West Virginia": "WV",
    Wisconsin: "WI",
    Wyoming: "WY",
  });

  const [permitteeTypes, setPermitteeTypes] = useState({
    Owner: "owner",
    Operator: "operator",
  });

  const [projectTypes, setProjectTypes] = useState({
    Development: "development",
    Residential: "residential",
    Commercial: "commercial",
    "Development & Residential": "development & residential",
    "Development & Commercial": "development & commercial",
  });

  const [unitTypes, setUnitTypes] = useState({
    "Single-Family": "S",
    "Multi-Family": "M",
    Both: "B",
  });

  const [cornerDirection, setCornerDirection] = useState({
    "North East": "NE",
    "North West": "NW",
    "South East": "SE",
    "South West": "SW",
  });

  const handleSelectChange = (e) => {
    const { value } = e.target;
    const newState = {
      ...state,
      [idProp]: value,
    };
    setState(newState);
    if (debouncedSave && setIsLoading && requestStatus !== "A") {
      setIsLoading(true);
      debouncedSave.mutate(newState);
    }
  };

  return (
    <div className={`select-info-container ${type}-info-container`}>
      <FormControl
        variant="outlined"
        id="select-form"
        classes={{ root: "form-select-root" }}
        className={`${type}-form-control ${
          requestStatus === "RV" &&
          disabledInput === false &&
          invalidData &&
          (val === invalidData["initialValue"] || val === "")
            ? "revise-input"
            : requestStatus === "RV" &&
                disabledInput === false &&
                invalidData &&
                val !== invalidData["initialValue"] &&
                val !== ""
              ? "revised-input"
              : handleInputDisable(idProp, state, disabledInput, userId) ===
                  true
                ? "disable-text"
                : req
                  ? "required"
                  : ""
        }`}
      >
        <InputLabel
          id="select-label"
          htmlFor="select-input"
          classes={{ shrink: "select-label-shrink" }}
          className={`${idProp}-select-field-label`}
        >
          {`${label}`}
        </InputLabel>
        <Select
          id="select-field"
          labelId="select-field-label"
          className={`${idProp}-input`}
          ref={textRef}
          label={`Select ${label}`}
          value={val}
          onChange={handleSelectChange}
          multiple={idProp === "specialServices" ? true : false}
          MenuProps={{
            id: "select-field-menu",
            className: "select-field-menu",
            classes: { paper: "select-field-paper" },
          }}
          inputProps={{
            id: "select-input",
            name: "select-input",
          }}
          disabled={
            handleInputDisable(idProp, state, disabledInput, userId) === true
              ? true
              : false
          }
          autoComplete="off"
          autoCapitalize="words"
          classes={{
            root: "select-field-root",
            input: "select-field-input",
          }}
        >
          <MenuItem
            value=""
            id="select-field-placeholder"
            className="select-placeholder"
          >
            Clear Field
          </MenuItem>
          {type === "state"
            ? Object.keys(states).map((state) => (
                <MenuItem
                  key={states[state]}
                  value={states[state]}
                  className="select-menu-item"
                >
                  {state}
                </MenuItem>
              ))
            : type === "permittee"
              ? Object.keys(permitteeTypes).map((permittee) => (
                  <MenuItem
                    key={permitteeTypes[permittee]}
                    value={permitteeTypes[permittee]}
                    className="select-menu-item"
                  >
                    {permittee}
                  </MenuItem>
                ))
              : type === "projectType"
                ? Object.keys(projectTypes).map((projectType) => (
                    <MenuItem
                      key={projectTypes[projectType]}
                      value={projectTypes[projectType]}
                      className="select-menu-item"
                    >
                      {projectType}
                    </MenuItem>
                  ))
                : type === "unitType"
                  ? Object.keys(unitTypes).map((unitType) => (
                      <MenuItem
                        key={unitTypes[unitType]}
                        value={unitTypes[unitType]}
                        className="select-menu-item"
                      >
                        {unitType}
                      </MenuItem>
                    ))
                  : type === "cornerDirection"
                    ? Object.keys(cornerDirection).map((corner) => (
                        <MenuItem
                          key={cornerDirection[corner]}
                          value={cornerDirection[corner]}
                          className="select-menu-item"
                        >
                          {corner}
                        </MenuItem>
                      ))
                    : null}
        </Select>
      </FormControl>
      <Tooltip
        id="tf-tooltip"
        classes={{
          tooltip: "text-field-tooltip",
          popper: "text-field-popper",
          arrow: "text-field-arrow",
          tooltipPlacementLeft: "text-field-right",
        }}
        title={Messages[`${idProp}Message`] || ""}
        placement={"top"}
        arrow
        open={open}
        sx={{
          backgroundColor: "rgb(0, 0, 0, 0.8) !important",
        }}
      >
        <InfoCircle
          className="text-info-circ"
          id={`info-${idProp}`}
          color="white"
          size={30}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        />
      </Tooltip>
    </div>
  );
};
export default NewSelect;
